
import { z } from "zod";

export const FileTagValues = ["AFTER_CLEAN_UP", "AFTER_WORK", "ANY_LUMBER_THAT_REQUIRED_REPLACEMENT", "ANY_LUMBER_THAT_REQUIRED_REPLACEMENT_IF_NECESSARY", "APPROVED_BY_REMI_OPERATIONS", "ATTIC_ACCESS", "BACK_ELEVATION", "BASE_FLASHINGS", "BEFORE_WORK", "BUILDING_PERMIT", "CAD_LAYOUT", "CERTIFICATE_OF_COMPLETION", "CERTIFICATE_OF_COMPLETION_INVOICE", "CHANGE_ORDER_ADDENDUM_PREVIEW", "CLEARANCE_BELOW_PANELS", "COMPLETED_WORK", "COMPLETION_OF_WORK_REPORT", "CONDUIT_RUNS", "CONFIRMATION_OF_SYSTEM_POWERED_ON_COMMUNICATING", "CORRECTIONS_WORK", "DAMAGE", "DECKING_CONDITION", "DESIGN_PLAN", "DUMPSTER_RECEIPT", "DURING_TEAR_OFF", "DURING_VENT_REMOVED_BASE_INSTALLED", "EAGLEVIEW", "ESTIMATE", "ESTIMATE_COVER_IMAGE", "ESX", "EXISTING_DECKING", "EXISTING_EQUIPMENT_INCLUDING_PANEL_SERIAL_STICKER_AND_FULL_GROUND_CONDUIT", "EXISTING_SYSTEM_PRIOR_TO_REMOVAL", "FIC", "FINAL_INSTALLATION", "FOOTING_SEALANT_WATERPROOFING_METHOD", "FRONT_ELEVATION", "FRONT_OF_HOME_INCLUDING_ADDRESS", "FSD_PORTAL", "FULL_FACE_REPLACEMENT", "FULL_GROUND_CONDUIT", "GEOMETRY", "GUTTERS_FINAL_CLEANUP_DEBRIS", "GUTTERS_FINAL_DOWNSPOUT_TERMINATION", "GUTTERS_FINAL_FRONT_ELEVATION", "GUTTERS_FINAL_LEFT_RIGHT_ELEVATIONS", "GUTTERS_FINAL_LONG_RUN_PITCH", "GUTTERS_FINAL_OUTLET_DROP_CONNECTION", "GUTTERS_FINAL_REAR_ELEVATION", "GUTTERS_FINAL_WATER_FLOW_TEST", "GUTTERS_MID_DOWNSPOUT_SECURED", "GUTTERS_MID_DRIP_EDGE_APRON", "GUTTERS_MID_END_CAP_SEALED", "GUTTERS_MID_FASCIA_ROOF_EDGE_BEFORE_HANG", "GUTTERS_MID_HIDDEN_HANGER_SPACING", "GUTTERS_MID_MITER_CORNER_SEAM_SEALED", "GUTTERS_PREJOB_EXISTING_FASCIA_ROOF_EDGE", "GUTTERS_PREJOB_FULL_FRONT_ELEVATION", "GUTTERS_PREJOB_FULL_REAR_ELEVATION", "GUTTERS_PREJOB_LEFT_RIGHT_ELEVATIONS", "GUTTERS_PREJOB_PRE_EXISTING_DAMAGE", "HIC", "HOVER", "IMAGES_FOR_WORK_ORDER", "INITIAL_PHOTOS", "INSPECTION_SITE_REPORT", "INSTALLATION_AREA_PRE_INSTALL", "INSTALLATION_LAYOUT", "INSURANCE_PORTAL", "ITEL_REPORT", "ITEL_ROOF_EXPOSED_HEIGHT", "ITEL_ROOF_OVERALL_COLOR", "ITEL_ROOF_PRIMARY_COLOR", "ITEL_ROOF_SECONDARY_COLOR", "ITEL_ROOF_SHINGLE_WIDTH", "ITEL_ROOF_THICKNESS", "ITEL_ROOF_TILE_BACK", "ITEL_ROOF_TILE_OVERALL", "ITEL_ROOF_TILE_TOP", "ITEL_SIDING_ANGLED_CLOSEUP", "ITEL_SIDING_DUTCH_LAP", "ITEL_SIDING_MANUFACTURER_CODE", "ITEL_SIDING_NAIL_HEM", "ITEL_SIDING_PROJECTION", "ITEL_SIDING_STRAIGHT_CLOSEUP", "ITEL_SIDING_THICKNESS", "ITEL_SIDING_TOTAL_EXPOSED_HEIGHT", "ITEL_SIDING_WEEP_HOLE", "LADDER_ACCESS", "LEFT_ELEVATION", "MATERIAL_INSTALL", "MATERIALS_RECEIPT", "MEASUREMENT_DATA", "MEASUREMENT_REPORT", "NAILING_PATTERNS", "NO_PERMIT_REQUIRED_EVIDENCE", "OTHER", "PANEL_REMOVAL_MARKUP", "PANELS_INSTALLED", "PATCH_REPAIR", "PDF_REPORT", "PERMIT_RECEIPT", "PHOTOS_OF_OPTIMIZER_MAP_IF_NECESSARY", "PHOTOS_OF_PANELS_PROPERLY_STORED", "PHOTOS_OF_SYSTEM_REMOVED_AND_ROOF_CLEARED_OF_ALL_MATERIAL", "PLAN_SET", "PREPARATION_WORK", "PROPOSAL", "QA_REPORT", "RACKING_MOUNTS", "RAFTER_CONDITION", "REINSTALL_COMPLETE", "RIGHT_ELEVATION", "ROOF_SKETCH", "ROOF_TIE_IN_PPE_FALL_PROTECTION", "ROOF_WITHOUT_PANELS", "ROOFING_COMPLETED_WORK", "SERVICE_CONTRACT", "SHADE_REPORT", "SIDING_FINAL_CLEANUP_DEBRIS", "SIDING_FINAL_CORNER_DETAIL", "SIDING_FINAL_DOOR_CLOSEUP", "SIDING_FINAL_FRONT_ELEVATION", "SIDING_FINAL_LEFT_ELEVATION", "SIDING_FINAL_LONG_WALL", "SIDING_FINAL_MATERIALS_WARRANTY", "SIDING_FINAL_PENETRATION_DETAIL", "SIDING_FINAL_REAR_ELEVATION", "SIDING_FINAL_RIGHT_ELEVATION", "SIDING_FINAL_ROOF_TRANSITION", "SIDING_FINAL_WINDOW_CLOSEUP", "SIDING_MID_CORNER_TRIM", "SIDING_MID_FASTENER_DETAIL", "SIDING_MID_HORIZONTAL_JOINT", "SIDING_MID_HOUSEWRAP_WRB", "SIDING_MID_PENETRATION_DETAIL", "SIDING_MID_ROOF_TO_WALL_KICKOUT", "SIDING_MID_STARTER_STRIP", "SIDING_MID_WIDE_50", "SIDING_MID_WIDE_90", "SIDING_MID_WINDOW_FLASHING", "SIDING_PREJOB_FULL_FRONT_ELEVATION", "SIDING_PREJOB_FULL_LEFT_ELEVATION", "SIDING_PREJOB_FULL_REAR_ELEVATION", "SIDING_PREJOB_FULL_RIGHT_ELEVATION", "SIDING_PREJOB_PRE_EXISTING_DAMAGE", "SINGLE_LINE_DIAGRAM", "SITE_AUDIT", "SITE_MAP_PANEL_LAYOUT", "SITE_VISIT_INVOICE", "SITE_VISIT_REPORT", "STEP_BACK_OF_ALL_MEMBERS", "STIPULATION_DOC", "STORED_PANELS", "STRINGMAP", "SUNRUN_PORTAL_SCREENSHOT", "SYSTEM_OPERATIONAL_BEFORE_POWERING_DOWN_FOR_REMOVAL", "SYSTEM_VALIDATION", "UNDERLAYMENT", "UNDERLAYMENT_INSTALLATION", "UNSIGNED_CERTIFICATE_OF_COMPLETION", "UNSIGNED_HIC", "VOLTAGE_TEST", "WIRE_GROUNDING", "WIRE_RUN_CABLE_MANAGEMENT", "WORK_AUTHORIZATION", "WORK_ORDER_SCOPE_PACKET", "XACTANALYSIS", "XACTIMATE_QUOTE", "R_1", "R_2", "R_3", "R_4", "R_5", "R_6", "R_7", "R_8", "R_9", "R_10", "R_11", "R_12", "R_13", "R_14", "R_15", "R_16", "R_17", "R_18", "R_19", "R_20", "R_21", "R_22", "R_23", "R_24", "R_25", "R_26", "R_27", "R_28", "R_29", "R_30", "R_31", "R_32", "R_33", "R_34", "R_35", "R_36", "R_37", "R_38", "R_39", "R_40", "R_41", "R_42", "R_43", "R_44", "R_45", "R_46", "R_47", "R_48", "R_49", "R_50", "SI_1", "SI_2", "SI_3", "SI_4", "SI_5", "SI_6", "SI_7", "SI_8", "SI_9", "SI_10", "SI_11", "SI_12", "SI_13", "SI_14", "SI_15", "SI_16", "SI_17", "SI_18", "SI_19", "SI_20", "SI_21", "SI_22", "SI_23", "SI_24", "SI_25", "SI_26", "SI_27", "SI_28", "SI_29", "SI_30", "SI_31", "SI_32", "SI_33", "SI_34", "SI_35", "SI_36", "SI_37", "SI_38", "SI_39", "SI_40", "SI_41", "SI_42", "SI_43", "SI_44", "SI_45", "SI_46", "SI_47", "SI_48", "SI_49", "SI_50"] as const;
export const FileTagSchema = z.enum(FileTagValues);
export const FileTag = FileTagSchema.enum;
export type FileTag = (typeof FileTagValues)[number];
export const FileTagDisplayNames = { "AFTER_CLEAN_UP": "After clean up",
"AFTER_WORK": "After work",
"ANY_LUMBER_THAT_REQUIRED_REPLACEMENT": "Any lumber that required replacement",
"ANY_LUMBER_THAT_REQUIRED_REPLACEMENT_IF_NECESSARY": "Any lumber that required replacement (if necessary)",
"APPROVED_BY_REMI_OPERATIONS": "Approved by Remi Operations",
"ATTIC_ACCESS": "Attic access",
"BACK_ELEVATION": "Back elevation",
"BASE_FLASHINGS": "Base flashings",
"BEFORE_WORK": "Before work",
"BUILDING_PERMIT": "Building permit",
"CAD_LAYOUT": "CAD layout",
"CERTIFICATE_OF_COMPLETION": "Certificate of completion",
"CERTIFICATE_OF_COMPLETION_INVOICE": "Certificate of completion invoice",
"CHANGE_ORDER_ADDENDUM_PREVIEW": "Change order addendum preview",
"CLEARANCE_BELOW_PANELS": "Clearance below panels",
"COMPLETED_WORK": "Completed work",
"COMPLETION_OF_WORK_REPORT": "Completion of work report",
"CONDUIT_RUNS": "Conduit run(s)",
"CONFIRMATION_OF_SYSTEM_POWERED_ON_COMMUNICATING": "Confirmation of system powered on/communicating",
"CORRECTIONS_WORK": "Corrections work",
"DAMAGE": "Damage",
"DECKING_CONDITION": "Decking condition",
"DESIGN_PLAN": "Design plan",
"DUMPSTER_RECEIPT": "Dumpster receipt",
"DURING_TEAR_OFF": "During tear off",
"DURING_VENT_REMOVED_BASE_INSTALLED": "During vent removed & base installed",
"EAGLEVIEW": "EagleView report",
"ESTIMATE": "Estimate",
"ESTIMATE_COVER_IMAGE": "Estimate cover image",
"ESX": "ESX file",
"EXISTING_DECKING": "Existing decking",
"EXISTING_EQUIPMENT_INCLUDING_PANEL_SERIAL_STICKER_AND_FULL_GROUND_CONDUIT": "Existing equipment (including panel serial # sticker) and full ground conduit",
"EXISTING_SYSTEM_PRIOR_TO_REMOVAL": "Existing system prior to removal",
"FIC": "FIC",
"FINAL_INSTALLATION": "Final installation",
"FOOTING_SEALANT_WATERPROOFING_METHOD": "Footing sealant/waterproofing method",
"FRONT_ELEVATION": "Front elevation",
"FRONT_OF_HOME_INCLUDING_ADDRESS": "Front of home including address",
"FSD_PORTAL": "FSD portal",
"FULL_FACE_REPLACEMENT": "Full face replacement",
"FULL_GROUND_CONDUIT": "Full ground conduit",
"GEOMETRY": "Geometry file",
"GUTTERS_FINAL_CLEANUP_DEBRIS": "Cleanup / debris removed",
"GUTTERS_FINAL_DOWNSPOUT_TERMINATION": "Downspout termination – extension / splash block",
"GUTTERS_FINAL_FRONT_ELEVATION": "Final front elevation",
"GUTTERS_FINAL_LEFT_RIGHT_ELEVATIONS": "Final left & right elevations",
"GUTTERS_FINAL_LONG_RUN_PITCH": "Long run showing straight line & pitch toward downspout",
"GUTTERS_FINAL_OUTLET_DROP_CONNECTION": "Outlet / downspout drop connection",
"GUTTERS_FINAL_REAR_ELEVATION": "Final rear elevation",
"GUTTERS_FINAL_WATER_FLOW_TEST": "Water flow test draining properly",
"GUTTERS_MID_DOWNSPOUT_SECURED": "Downspout secured to wall (straps / brackets)",
"GUTTERS_MID_DRIP_EDGE_APRON": "Drip edge / gutter apron",
"GUTTERS_MID_END_CAP_SEALED": "End cap sealed",
"GUTTERS_MID_FASCIA_ROOF_EDGE_BEFORE_HANG": "Fascia / roof edge before gutter is hung",
"GUTTERS_MID_HIDDEN_HANGER_SPACING": "Hidden hanger spacing & attachment",
"GUTTERS_MID_MITER_CORNER_SEAM_SEALED": "Miter / corner seam sealed",
"GUTTERS_PREJOB_EXISTING_FASCIA_ROOF_EDGE": "Existing fascia / roof edge condition",
"GUTTERS_PREJOB_FULL_FRONT_ELEVATION": "Full front elevation",
"GUTTERS_PREJOB_FULL_REAR_ELEVATION": "Full rear elevation",
"GUTTERS_PREJOB_LEFT_RIGHT_ELEVATIONS": "Left & right elevations – each run getting gutters",
"GUTTERS_PREJOB_PRE_EXISTING_DAMAGE": "Pre-existing damage areas",
"HIC": "HIC",
"HOVER": "Hover report",
"IMAGES_FOR_WORK_ORDER": "Images for work order",
"INITIAL_PHOTOS": "Initial photos",
"INSPECTION_SITE_REPORT": "Inspection site report",
"INSTALLATION_AREA_PRE_INSTALL": "Installation area (pre-install)",
"INSTALLATION_LAYOUT": "Installation layout",
"INSURANCE_PORTAL": "Files uploaded through insurance portal",
"ITEL_REPORT": "ITEL report",
"ITEL_ROOF_EXPOSED_HEIGHT": "ITEL exposed height",
"ITEL_ROOF_OVERALL_COLOR": "ITEL overall roof color",
"ITEL_ROOF_PRIMARY_COLOR": "ITEL primary color",
"ITEL_ROOF_SECONDARY_COLOR": "ITEL secondary color",
"ITEL_ROOF_SHINGLE_WIDTH": "ITEL shingle width",
"ITEL_ROOF_THICKNESS": "ITEL roof thickness",
"ITEL_ROOF_TILE_BACK": "ITEL roof tile back",
"ITEL_ROOF_TILE_OVERALL": "ITEL roof tile overall",
"ITEL_ROOF_TILE_TOP": "ITEL roof tile top",
"ITEL_SIDING_ANGLED_CLOSEUP": "ITEL angled close-up",
"ITEL_SIDING_DUTCH_LAP": "ITEL dutch lap",
"ITEL_SIDING_MANUFACTURER_CODE": "ITEL manufacturer code",
"ITEL_SIDING_NAIL_HEM": "ITEL nail hem",
"ITEL_SIDING_PROJECTION": "ITEL projection",
"ITEL_SIDING_STRAIGHT_CLOSEUP": "ITEL straight close-up",
"ITEL_SIDING_THICKNESS": "ITEL siding thickness",
"ITEL_SIDING_TOTAL_EXPOSED_HEIGHT": "ITEL total exposed height",
"ITEL_SIDING_WEEP_HOLE": "ITEL weep hole",
"LADDER_ACCESS": "Ladder access",
"LEFT_ELEVATION": "Left elevation",
"MATERIAL_INSTALL": "Material install",
"MATERIALS_RECEIPT": "Materials receipt",
"MEASUREMENT_DATA": "Measurement data file",
"MEASUREMENT_REPORT": "Measurement report",
"NAILING_PATTERNS": "Nailing patterns",
"NO_PERMIT_REQUIRED_EVIDENCE": "No permit required evidence",
"OTHER": "Other",
"PANEL_REMOVAL_MARKUP": "Panel removal markup",
"PANELS_INSTALLED": "Panels installed",
"PATCH_REPAIR": "Patch repair",
"PDF_REPORT": "Report PDF",
"PERMIT_RECEIPT": "Permit receipt",
"PHOTOS_OF_OPTIMIZER_MAP_IF_NECESSARY": "Photos of optimizer map (if necessary)",
"PHOTOS_OF_PANELS_PROPERLY_STORED": "Photos of panels properly stored",
"PHOTOS_OF_SYSTEM_REMOVED_AND_ROOF_CLEARED_OF_ALL_MATERIAL": "Photos of system removed and roof cleared of all material",
"PLAN_SET": "Plan set",
"PREPARATION_WORK": "Preparation work",
"PROPOSAL": "Proposal",
"QA_REPORT": "QA report",
"RACKING_MOUNTS": "Racking/mounts",
"RAFTER_CONDITION": "Rafter condition",
"REINSTALL_COMPLETE": "Reinstall complete",
"RIGHT_ELEVATION": "Right elevation",
"ROOF_SKETCH": "Roof sketch",
"ROOF_TIE_IN_PPE_FALL_PROTECTION": "Roof tie-in/PPE/fall protection",
"ROOF_WITHOUT_PANELS": "Roof without panels",
"ROOFING_COMPLETED_WORK": "Roofing completed work",
"SERVICE_CONTRACT": "Service contract",
"SHADE_REPORT": "Shade report",
"SIDING_FINAL_CLEANUP_DEBRIS": "Cleanup / debris removed",
"SIDING_FINAL_CORNER_DETAIL": "Corner detail",
"SIDING_FINAL_DOOR_CLOSEUP": "Door close-up",
"SIDING_FINAL_FRONT_ELEVATION": "Final front elevation",
"SIDING_FINAL_LEFT_ELEVATION": "Final left elevation",
"SIDING_FINAL_LONG_WALL": "Long wall showing straight lines / courses",
"SIDING_FINAL_MATERIALS_WARRANTY": "Final materials or warranty photo",
"SIDING_FINAL_PENETRATION_DETAIL": "Penetration detail",
"SIDING_FINAL_REAR_ELEVATION": "Final rear elevation",
"SIDING_FINAL_RIGHT_ELEVATION": "Final right elevation",
"SIDING_FINAL_ROOF_TRANSITION": "Roof transition detail",
"SIDING_FINAL_WINDOW_CLOSEUP": "Window close-up",
"SIDING_MID_CORNER_TRIM": "Corner / trim integration",
"SIDING_MID_FASTENER_DETAIL": "Fastener detail close-up",
"SIDING_MID_HORIZONTAL_JOINT": "Horizontal joint / butt joint detail",
"SIDING_MID_HOUSEWRAP_WRB": "Housewrap / WRB exposed before siding install",
"SIDING_MID_PENETRATION_DETAIL": "One penetration detail (light / vent / hose bib)",
"SIDING_MID_ROOF_TO_WALL_KICKOUT": "Roof-to-wall / kickout flashing",
"SIDING_MID_STARTER_STRIP": "Starter strip / first course",
"SIDING_MID_WIDE_50": "Wide shot at ~50% completion",
"SIDING_MID_WIDE_90": "Wide shot at ~90% completion",
"SIDING_MID_WINDOW_FLASHING": "Window flashing detail close-up",
"SIDING_PREJOB_FULL_FRONT_ELEVATION": "Full front elevation",
"SIDING_PREJOB_FULL_LEFT_ELEVATION": "Full left elevation",
"SIDING_PREJOB_FULL_REAR_ELEVATION": "Full rear elevation",
"SIDING_PREJOB_FULL_RIGHT_ELEVATION": "Full right elevation",
"SIDING_PREJOB_PRE_EXISTING_DAMAGE": "Pre-existing damage areas",
"SINGLE_LINE_DIAGRAM": "Single line diagram",
"SITE_AUDIT": "Site audit",
"SITE_MAP_PANEL_LAYOUT": "Site map/Panel layout (including serial numbers)",
"SITE_VISIT_INVOICE": "Site visit invoice",
"SITE_VISIT_REPORT": "Site visit report",
"STEP_BACK_OF_ALL_MEMBERS": "Step back of all members",
"STIPULATION_DOC": "Stipulation document",
"STORED_PANELS": "Stored panels",
"STRINGMAP": "Stringmap",
"SUNRUN_PORTAL_SCREENSHOT": "Sunrun portal screenshot",
"SYSTEM_OPERATIONAL_BEFORE_POWERING_DOWN_FOR_REMOVAL": "System operational before powering down for removal",
"SYSTEM_VALIDATION": "System validation",
"UNDERLAYMENT": "Underlayment",
"UNDERLAYMENT_INSTALLATION": "Underlayment installation",
"UNSIGNED_CERTIFICATE_OF_COMPLETION": "Unsigned certificate of completion",
"UNSIGNED_HIC": "Unsigned HIC",
"VOLTAGE_TEST": "Voltage test",
"WIRE_GROUNDING": "Wire grounding",
"WIRE_RUN_CABLE_MANAGEMENT": "Wire run/cable management",
"WORK_AUTHORIZATION": "Work authorization",
"WORK_ORDER_SCOPE_PACKET": "Work order scope packet",
"XACTANALYSIS": "Xactanalysis",
"XACTIMATE_QUOTE": "Xactimate quote",
"R_1": "R-1",
"R_2": "R-2",
"R_3": "R-3",
"R_4": "R-4",
"R_5": "R-5",
"R_6": "R-6",
"R_7": "R-7",
"R_8": "R-8",
"R_9": "R-9",
"R_10": "R-10",
"R_11": "R-11",
"R_12": "R-12",
"R_13": "R-13",
"R_14": "R-14",
"R_15": "R-15",
"R_16": "R-16",
"R_17": "R-17",
"R_18": "R-18",
"R_19": "R-19",
"R_20": "R-20",
"R_21": "R-21",
"R_22": "R-22",
"R_23": "R-23",
"R_24": "R-24",
"R_25": "R-25",
"R_26": "R-26",
"R_27": "R-27",
"R_28": "R-28",
"R_29": "R-29",
"R_30": "R-30",
"R_31": "R-31",
"R_32": "R-32",
"R_33": "R-33",
"R_34": "R-34",
"R_35": "R-35",
"R_36": "R-36",
"R_37": "R-37",
"R_38": "R-38",
"R_39": "R-39",
"R_40": "R-40",
"R_41": "R-41",
"R_42": "R-42",
"R_43": "R-43",
"R_44": "R-44",
"R_45": "R-45",
"R_46": "R-46",
"R_47": "R-47",
"R_48": "R-48",
"R_49": "R-49",
"R_50": "R-50",
"SI_1": "SI-1",
"SI_2": "SI-2",
"SI_3": "SI-3",
"SI_4": "SI-4",
"SI_5": "SI-5",
"SI_6": "SI-6",
"SI_7": "SI-7",
"SI_8": "SI-8",
"SI_9": "SI-9",
"SI_10": "SI-10",
"SI_11": "SI-11",
"SI_12": "SI-12",
"SI_13": "SI-13",
"SI_14": "SI-14",
"SI_15": "SI-15",
"SI_16": "SI-16",
"SI_17": "SI-17",
"SI_18": "SI-18",
"SI_19": "SI-19",
"SI_20": "SI-20",
"SI_21": "SI-21",
"SI_22": "SI-22",
"SI_23": "SI-23",
"SI_24": "SI-24",
"SI_25": "SI-25",
"SI_26": "SI-26",
"SI_27": "SI-27",
"SI_28": "SI-28",
"SI_29": "SI-29",
"SI_30": "SI-30",
"SI_31": "SI-31",
"SI_32": "SI-32",
"SI_33": "SI-33",
"SI_34": "SI-34",
"SI_35": "SI-35",
"SI_36": "SI-36",
"SI_37": "SI-37",
"SI_38": "SI-38",
"SI_39": "SI-39",
"SI_40": "SI-40",
"SI_41": "SI-41",
"SI_42": "SI-42",
"SI_43": "SI-43",
"SI_44": "SI-44",
"SI_45": "SI-45",
"SI_46": "SI-46",
"SI_47": "SI-47",
"SI_48": "SI-48",
"SI_49": "SI-49",
"SI_50": "SI-50", } satisfies Record<FileTag, string>;
